<template>
  <div class="course">
    <div
      class="time-line"
      v-for="(item, index) in list"
      :key="index"
      :class="!item.show ? 'hidden-time-line' : ''"
    >
      <div class="item-border">
        <div class="line-item">
          <div class="time-div">
            <span class="time-span">{{ item.time }}</span>
          </div>
          <div class="time-con" v-if="item.show">
            <p class="title">{{ item.address }}</p>
            <p class="doc">{{ item.doc }}</p>
            <!-- <img
              class="line-img"
              :src="require(`../../../assets/images/about/${item.img}.png`)"
              alt=""
            /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Course",
  data() {
    return {
      list: [
        {
          show: true,
          time: "2022",
          address:
            "受疫情影响，人员禁止流动或扎堆，学校网上授课，此时自助打印的便捷性给广大用户带来更实用的打印体验",
          //   doc: "成立技术研发总部，位于北京CBD核心区域",
          img: "tec"
        },
        {
          show: true,
          time: "2021",
          address: "微信小程序打印上线，为用户提供更便利的打印工具",
          //   doc: "成立大型行业研究及商务中心",
          img: "tec"
        },
        {
          show: true,
          time: "2020",
          address: "全国高校设备1500台 社区便利店设备3500台",
          //   doc: "成立国家级硬件开发实验室",
          img: "tec"
        },
        {
          show: true,
          time: "2019",
          address:
            "获得中国大学生创新大赛全国二等奖、大学生创业园优秀项目等奖项",
          //   doc: "正式成立，致力于工业互联网及量子物理行业应用",
          img: "tec"
        },
        {
          show: true,
          time: "2018",
          address: "开拓社区便利店校外市场",
          //   doc: "成立技术研发总部，位于北京CBD核心区域",
          img: "tec"
        },
        {
          show: true,
          time: "2017",
          address: "获得天使轮A轮B轮融资",
          //   doc: "成立技术研发总部，位于北京CBD核心区域",
          img: "tec"
        },
        {
          show: true,
          time: "2016",
          address: "初创团队组建",
          //   doc: "成立技术研发总部，位于北京CBD核心区域",
          img: "tec"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.course {
  width: 100%;
  .time-line {
    width: 100%;
    margin: auto;
    height: 150px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      width: 20px;
      height: 20px;
      margin: 10px;
      z-index: 2;
      border-radius: 50%;
      background: #ffffff;
      border: 5px solid #fde101;
      position: absolute;
      top: 0px;
      left: calc(50% - 20px);
    }
    &:nth-child(even) {
      background-color: #faf9f7;
      .item-border {
        position: absolute;
        left: -4px;
        border-right: 2px solid #e5e5e5;
        .line-item {
          .time-div {
            position: absolute;
            right: -200px;
            top: 5px;
          }
          .time-con {
            text-align: right;
            margin-right: -150px;
          }
        }
      }
    }
    &:nth-child(odd) {
      .item-border {
        position: absolute;
        right: -4px;
        border-left: 2px solid #e5e5e5;
        .line-item {
          position: absolute;
          right: 0;
          .time-div {
            position: absolute;
            left: -320px;
            top: 5px;
          }
          .time-con {
            text-align: left;
            margin-left: -150px;
          }
        }
      }
    }
    .item-border {
      width: 605px;
      height: 100%;
      .line-item {
        width: 430px;
        height: 100%;
        position: absolute;
        top: 0;
        padding: 20px 30px;
        .time-div {
          width: calc(13.5px + 1.7px);
          height: 30px;
          .time-span {
            display: inline-block;
            width: 135px;
            height: 31px;
            border-radius: 20px;
            color: #323232;
            font-family: PingFang SC;
            font-weight: 500;
            text-align: center;
            line-height: 31px;
            margin: auto;
            font-size: 28px;
          }
        }
        .time-con {
          .title {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #323232;
          }
          .doc {
            font-size: 14px;
            color: #666666;
            margin: 18px 0;
          }
          .line-img {
            width: 370px;
            height: 210px;
            border-radius: 10px;
          }
        }
      }
    }
  }

  .hidden-time-line {
    height: 3px;
    & .item-border {
      border: none !important;
      .line-item {
        background: #ffffff;
      }
    }
  }
}
</style>
